import React from 'react'
import { Modal } from 'react-bootstrap'
import './ModalPopUpCompraMedicamento.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faXmark } from '@fortawesome/free-solid-svg-icons';

export const ModalPopUpCompraMedicamento = ({showModalPopUpCompraMedicamento, handleCloseModalPopUpCompraMedicamento, medicamento}) => {
    const [imageLoading, setImageLoading] = React.useState(true)
    const windowWidth = window.innerWidth;

    const goVonline = () => {
        window.open(medicamento.woo_url, '_blank')
        handleCloseModalPopUpCompraMedicamento()
    }
    const LlamarContac = () => {
        window.location.href = "tel:6003001515";
      };

  return (
   <Modal show={showModalPopUpCompraMedicamento} size='lg' centered onHide={handleCloseModalPopUpCompraMedicamento}  style={{ width: '100%' }}>
        <Modal.Body >
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faXmark} size='xl' onClick={handleCloseModalPopUpCompraMedicamento} className='icon-stock'/>
            </div>
            <div className='row borde-modal'>
                <div className={`col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 ${windowWidth > 576 ? 'd-flex align-items-center ps-5' : 'text-center'}`}>
                        {/*Aqui va una imagen centrada */}
                        {imageLoading && <p>Cargando...</p>}
                        <img  onLoad={() => setImageLoading(false)}  src='/mensaje.png' alt='imagen informacion' className='img-fluid' style={{ maxWidth: '200px', width: '100%', height: 'auto' }}/>
                </div>
                <div className='col-12 col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 d-flex align-items-center pt-5 pb-5'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pe-5'>
                    <h3>Tenga en consideración</h3>
                    </div>
                    <div className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 ${windowWidth > 576 ? 'pe-5' : null}`}>
                     <p>Venta Online disponible en Santiago, Concepción, Talcahuano, San Pedro de la Paz y Hualpén.</p>
                    </div>
                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                    Venta Telefónica<button className="boton llamar-sinMed ms-3" onClick={LlamarContac}>
                                        <FontAwesomeIcon icon={faPhone} className="pe-2" />
                                        6003001515
                                      </button>
                    </div>
                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                    <button className='boton-continuar' onClick={goVonline}>CONTINUAR</button>
                    </div>
                    </div>
                </div>
            </div>
        </Modal.Body>
   </Modal>
  )
}
